import React from "react";
import ServicePageShell from "../components/ServicePageShell";
import { createBreadcrumbList } from "../utils/seo";

const PrivacyPolicy = () => {
  const schemas = [
    createBreadcrumbList([
      { name: "Home", path: "/" },
      { name: "Privacy Policy", path: "/privacy-policy" },
    ]),
  ];

  return (
    <ServicePageShell
      title="Privacy Policy | QBits9"
      description="Learn how QBits9 collects, uses, and protects personal information when you use our website or request AI automation and custom software services."
      canonicalPath="/privacy-policy"
      keywords="privacy policy QBits9, data protection, personal information"
      schemas={schemas}
    >
      <section className="relative overflow-hidden bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 md:py-24 lg:px-16">
          <div className="space-y-8">
            <span className="font-peachi text-[16px] md:text-[18px] text-black font-[500] mb-3">
              Privacy policy
            </span>
            <h1 className="text-black xl:text-[58px] lg:text-[50px] md:text-[42px] text-[28px] font-bold leading-[1.2]">
              QBits9 Privacy Policy
            </h1>
            <p className="max-w-3xl text-lg leading-8 text-slate-600 font-poppins">
              This policy explains how QBits9 collects, uses, stores, and protects the information you provide when visiting our website or contacting us about AI automation, custom software, ERP integrations, and related services.
            </p>
          </div>

          <div className="mt-12 space-y-12 text-slate-700 font-poppins">
            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Information We Collect</h2>
              <p className="leading-7 mb-3">
                We collect information you provide directly when you submit a contact form, request an audit, or email us. This may include your name, company name, email, phone number, website, project details, and budget.
              </p>
              <p className="leading-7">
                We may also collect information automatically through cookies and similar technologies, such as your browser type, device, IP address, and pages visited on our site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">How We Use Your Information</h2>
              <p className="leading-7 mb-3">
                We use your information to respond to inquiries, provide estimates, plan consultations, and improve our services. We also use contact data to send relevant updates about QBits9 services when you request information.
              </p>
              <p className="leading-7">
                We do not sell your personal information to third parties. We may share it with service providers who support our website and outreach, but only when necessary and in accordance with this policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Cookies and Tracking</h2>
              <p className="leading-7 mb-3">
                Our website may use cookies and analytics tools to understand how visitors use the site, improve performance, and deliver a better experience. These technologies typically collect anonymous usage data.
              </p>
              <p className="leading-7">
                You can disable cookies in your browser settings, but some features of the website may not function as intended if cookies are blocked.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Data Security</h2>
              <p className="leading-7 mb-3">
                QBits9 maintains reasonable organizational and technical safeguards to protect personal information from unauthorized access, loss, misuse, or alteration.
              </p>
              <p className="leading-7">
                While we strive to protect your data, no internet transmission or storage system is completely secure. You should take care when sharing sensitive information online.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-4">Contact Us</h2>
              <p className="leading-7">
                If you have questions about this privacy policy or want to update your information, please contact us at 
                {/* <a href="mailto:hello@qbits9.com" className="text-primary hover:underline">hello@qbits9.com
                    </a>. */}
              </p>
            </section>
          </div>
        </div>
      </section>
    </ServicePageShell>
  );
};

export default PrivacyPolicy;
